export function PlusSmallIcon({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 6H8V3C8 2.45 7.55 2 7 2C6.45 2 6 2.45 6 3V6H3C2.45 6 2 6.45 2 7C2 7.55 2.45 8 3 8H6V11C6 11.55 6.45 12 7 12C7.55 12 8 11.55 8 11V8H11C11.55 8 12 7.55 12 7C12 6.45 11.55 6 11 6Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
}
